import { ReactNode } from 'react'

interface FrequencyGroupProps {
  children: ReactNode
  label: ReactNode
}

export const FrequencyGroup = ({ children, label }: FrequencyGroupProps) => {
  return (
    <section className="mb-4 last-of-type:mb-0">
      <p className="mb-1.5 text-[22px] font-semibold leading-[120%] text-text-tertiary">{label}</p>
      <div className="flex flex-col gap-1.5">{children}</div>
    </section>
  )
}
